import { Loader2 } from "lucide-react";
import { Navigate } from "react-router-dom";

import { useAuth } from "@/context/AuthContext";

export function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="loading-screen">
      <Loader2 className="h-8 w-8 animate-spin text-primary" strokeWidth={1.5} />
    </div>
  );
}

export function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  if (user === undefined) return <LoadingScreen />;
  if (!user) return <Navigate to="/auth" replace />;
  if (!user.role) return <Navigate to="/completar-perfil" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}
